import React, { Component, PropTypes } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import { Input, Accordion, AccordionBody, AccordionHeader, AccordionItem, TabContent, TabPane, Nav, NavItem, NavLink, Table } from 'reactstrap';
import axios from 'axios';
import classnames from 'classnames';
import VendVendorContacts from '././vendVendorContacts';
import { VendSystems } from '././vendSystems';
import moment from 'moment';

export class VendVendors extends Component {
    static displayName = VendVendors.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.userData,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            vendorList: [],
            loadVend: false,
            tabActive: null,
            vendActive: this.props.vendpk,
            sysActive: null,
            sysOptions: [],
            sysFlag: "DEFAULT"
        }
        this.getVendList();
    }

    async getVendList() {//This was initially envisioned to take a parameter and be a search filtered fetch, but I decided instead to make it retrieve everybody instead.
                            //This way, I can use the same list as a dropdown select and to display the relevant information. There's only a couple fields here so it works.
        let toSend = {
            userlevel: this.props.userData.level
        }
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('GetVendorList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            vendorList: data
        })
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {//You'll see this a lot with the VendorDB components. Because each of these have to flow into and out of each other, when the parent updates
                                                //its active selection that filters down into its children's props. But unless the child knows to listen for those changing props, it won't
                                                //rerender with the new data. This could be accomplished by a key prop, I suppose, but given the different behaviors that need to be happening
                                                //when an update happens doing it in here is probably better.
                                                //Important to note, though, because componentDidUpdate executes whenever something updates the component, like setState, putting a this.setState
                                                //in here is Dangerous. This is why I have to take pains in the if statement to make sure we are only executing in certain circumstances and those
                                                //circumstances don't include when I simply update a state value.
        if (this.props.vendpk != null && this.state.vendorList.length > 0 && this.state.loadVend === false) {//If this isn't a top-level mounted component and we have a list of vendors already
                                                                                                                //and we're not already displaying the table, show it
            this.setState({
                loadVend: true
            })
        }
        if (prevProps.vendpk !== this.props.vendpk && this.props.vendpk != null && this.state.loadVend !== false) {//If the vendpk prop has changed and isn't null anymore and we are displaying
                                                                                                                    //displaying the table, change the actively displayed vendor to the new prop's
            this.setState({
                vendActive: this.props.vendpk
            })
        }
    }

    async getSysOptions(pk) {//The fact that we're making a call to retrieve all of the systems is a bit over the top, but we can filter out the ones we need on client-side
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level,
            vendorpk: pk
        }
        const response = await fetch('GetVendorSystems', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            sysOptions: data
        })
    }

    vendSelect(target) {
        this.setState({
            vendActive: target,
            sysFlag: "DEFAULT",//In order to make sure the System select data as well as VendSystems is cleared properly, we have to reset all of the VendSystems management state values
            sysActive: null,
            loadVend: true,//Also, turn off the VendVendors rendering briefly while we sort this out
            sysOptions: []
        }, () => {this.getSysOptions(target) })//That way, when we go to get the most recent system data, we can be confident we're displaying the correct stuff
    }

    tabToggle(tab) {
        if (this.state.tabActive !== tab) {
            this.setState({
                tabActive: tab
            });
        }
    }

    displayVend() {
        let vendRef = this.state.vendorList.filter(f => { return f.pk === this.state.vendActive });//Instead of making a fetch for this parameter's data, we can just get all the data we need 
                                                                                                    //and then filter it in client. Works like a charm.
        return (<div>
            <div style={{ color: vendRef[0].active ? '' : 'red' }}><h3>{vendRef[0].vendorname}</h3><p />
                <b>{vendRef[0].description}</b></div>
            <p />
            <Nav tabs>
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '1' })} onClick={() => this.tabToggle('1')}>
                        Contacts
                    </NavLink>
                </NavItem>
                {this.props.renderSource !== "sys" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '2' })} onClick={() => this.tabToggle('2')}>
                        Systems
                    </NavLink>
                </NavItem>}
            </Nav>
            <TabContent activeTab={this.state.tabActive}>
                <TabPane tabId='1'>
                    <div className="vendorChild"><VendVendorContacts vendpk={vendRef[0].pk} userData={this.props.userData} /></div>
                </TabPane>
                {this.props.renderSource !== "sys" && <TabPane tabId='2'>
                    <Input type="select" name="sysoptions" id="sysoptions" value={this.state.sysFlag} onChange={(e) => { this.setState({ sysFlag: e.target.value, sysActive: this.state.sysOptions.filter(i => {return i.pk === e.target.value }) }) }} className="halfOfParent">
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.sysOptions.map(item => (
                            <option value={item.pk}>{item.sysname}</option>
                        )) }
                    </Input>
                    <p />
                    {this.state.sysActive !== null && <div className="vendorChild"><VendSystems userData={this.props.userData} syspk={this.state.sysActive} renderSource={"vend"} /></div>}
                </TabPane>}
            </TabContent>
        </div>)
    }

    render() {
        let displayVendData = <div></div>
        if (this.state.loadVend) {displayVendData = this.displayVend() }
        return (<div>
            {this.props.vendpk == null && <h2>Vendors</h2>}<p />
            {this.props.vendpk == null && <Input type="select" name="vendor" id="vendor" defaultValue="DEFAULT" onChange={(e) => this.vendSelect(e.target.value)}>
                <option value="DEFAULT" disabled>Select...</option>
                {this.state.vendorList.map(item => (
                    <option value={item.pk}>{item.vendorname}</option>
                ))}
            </Input>}
            <br />
            {displayVendData}
        </div>)
    }
}